import React from 'react';
import ResetPassword from '../components/ResetPassword';
import completeNewPassword from '../actions/completeNewPassword';
import pendo from '../services/pendo';

export const context = 'resetPassword';
export class ResetPasswordRoute extends React.PureComponent {
    render() {
        return (
            <ResetPassword
                context={context}
                action={formData =>
                    completeNewPassword(formData, () => {
                        pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Reset Password Complete');
                    })
                }
            />
        );
    }
}

export default ResetPasswordRoute;
